import './App.css';
import { useState, useEffect } from "react";
import lottie from "lottie-web";

import { Homepage, About, DevScreen, NotFound, NavigationBar } from './components'
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from 'react-router-dom'

import { ThemeProvider, createTheme } from '@mui/material';
import { Box as GBox, Avatar } from "grommet";
import rocket from "./assets/images/rocket.json";

const theme = createTheme({
  /*
  primary: {
    //main: '#392f5a',
    main: '#01074f',
    light: '#68539c',
    dark: '#241e39',
    contrastText: '#e8eddf',
  },*/
  palette: {
    primary: {
      main: '#2A2550',

    },
   
    secondary: {
      main: '#E04D01',
      light: '#d0355b',
      dark: '#9c0229',
      contrastText: '#e8eddf',
    },
    tertiary:{
        main:'#ffffff'
    },
    error: {
      main: '#E30118',
    },
    warning: {
      main: '#251D3A',
    },
    success: {
      main: '#FDD900',
    },

  },
});

function App() {
  let [loading, setLoading] = useState(false);
  const setAnimation = async() => {
     setLoading(false);
  }
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector("#rocket-animation"),
      animationData: rocket,
    });
    const timeout = setTimeout(setAnimation, 2000);
    window.addEventListener('click', () => console.log('click'))
  }, []);

  const handleClickOutside = () => {
    console.log(0);
  };

  if(!loading) {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Router>
          <NavigationBar />
          <Routes>

            <Route path="/about" element={<About />} />
            <Route path="/dev" element={<DevScreen />} />
            <Route path="/home" element={<Homepage />} />
            <Route path="/" element={<Homepage />} />
            <Route path="*" element={<NotFound />} />


          </Routes>
        </Router>
      </ThemeProvider>
    </div >
  );
  }
  else if(loading) {
    return (
      <div style={{ display:'flex',flexDirection:'column' ,justifyContent:'center', alignItems:'center',  background: "#241E39", height:'100vh' }}>
        <GBox
            id="rocket-animation"
            direction="column"
            style={{
              justifyContent:'center',
              alignItems:'center',
              width: '35em',
              height: '35em',
              position: "relative",
             
            }}
          ></GBox>
          <h3 style={{color:'#f3f3f3', margin:0,}}>Travelling to planet Jatin!</h3>
      </div>
    )
  }
}

export default App;
